import { render, staticRenderFns } from "./config-menu.vue?vue&type=template&id=1803da55&scoped=true"
import script from "./config-menu.vue?vue&type=script&lang=js"
export * from "./config-menu.vue?vue&type=script&lang=js"
import style0 from "./config-menu.vue?vue&type=style&index=0&id=1803da55&prod&lang=scss"
import style1 from "./config-menu.vue?vue&type=style&index=1&id=1803da55&prod&scoped=true&lang=css"
import style2 from "./config-menu.vue?vue&type=style&index=2&id=1803da55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1803da55",
  null
  
)

export default component.exports